export const asLocaleField = (node = {}, key = '', locale = 'pl') => {
    return node[`${key}_${locale}`]
}

export default asLocaleField
